// This code converts a file to base64.
// It is used in the image upload component to convert an image to base64 so that it can be uploaded to the server.
export function getBase64ContentFromFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = (error) => reject(error);
  });
}
